// extracted by mini-css-extract-plugin
module.exports = {"text":"Icons_text__plZsr","item":"Icons_item__RTJQ_","button":"Icons_button__kE5dg","link":"Icons_link__2IBqv","icon":"Icons_icon__Sl6Iy"};